import { render, staticRenderFns } from "./CardColumnGroups.vue?vue&type=template&id=0524095a"
import script from "./CardColumnGroups.vue?vue&type=script&lang=js"
export * from "./CardColumnGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports